import { Answer, AnswerTask } from '@legalshield/frontend-commons-fetch/answers';
import { useMutation } from '@tanstack/react-query';

import { Attachment } from '../components/ReferralNetworkApplication/QuestionnaireResponse.interfaces';
import { findAttachments, uploadAttachments, UploadedDocumentResponse } from '../services/answers/attachments';
import createAnswers from '../services/answers/createAnswers';
import replaceAnswer from '../services/answers/replaceAnswer';
import submitAnswer from '../services/answers/submitAnswer';

type SubmitAnswerParams = {
  tasks: Record<string, any>;
  questionnaireName: string;
};
const useSubmitAnswerTest = () => {
  return useMutation(async ({ tasks, questionnaireName }: SubmitAnswerParams) => {
    const answer: Answer = await createAnswers({
      questionnaireName,
      taskCount: 17,
      tasks,
    });

    const version = answer.version as number;
    const id = answer.id as string;
    const ownerId = answer.ownerId as string;

    const uploadedDocs = await uploadAttachments(findAttachments(tasks), ownerId, id);

    tasks.task14.attachments.forEach((attachment: Attachment) => {
      const uploadResponse = uploadedDocs.find(
        (response: UploadedDocumentResponse) => response.filename === attachment.filename,
      );
      if (uploadResponse) {
        attachment.url = uploadResponse.url;
        attachment.preview = uploadResponse.url;
      }
    });

    const replacedAnswer: Answer = await replaceAnswer(version, id, {
      questionnaireName,
      taskCount: 17,
      tasks: tasks as unknown as Record<string, AnswerTask>,
    });

    await submitAnswer(replacedAnswer.version, id);
  });
};

export default useSubmitAnswerTest;
